import {CampaignOrigin} from '@/types/certification'

/**
 * Returns the localized label for a {@link CampaignOrigin}. `CampaignOrigin`
 * is not a badge enum (no variant, no icon), so it keeps its pure-label
 * resolver here rather than becoming an {@code EnumValue} subclass.
 */
export function campaignOriginLabel(
    origin: CampaignOrigin,
    labels: {originManual: string; originPolicyGenerated: string},
): string {
    switch (origin) {
        case CampaignOrigin.MANUAL:
            return labels.originManual
        case CampaignOrigin.POLICY_GENERATED:
            return labels.originPolicyGenerated
    }
}
